import React, { useState } from 'react';
import { List, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUnsavedChanges } from '../../hooks/useUnsavedChanges';

function Profile() {
    const { t } = useTranslation();
    const { logoutUser, user } = useAuth();
    const { guard } = useUnsavedChanges();
    const [toggleProfile, setToggleProfile] = useState(null);
    const open = Boolean(toggleProfile);
    const navigate = useNavigate();

    const id = open ? 'profile-popover' : undefined;

    const popoverStyle = {
        '& .MuiPaper-root': {
            borderRadius: 1,
            marginTop: 0,
            borderTopWidth: 1,
        },
    };

    return (
        <>
            <Typography
                variant="body2"
                style={{ flexGrow: 1 }}
                onClick={(e) => setToggleProfile(e.currentTarget)}
            >
                {user?.name}
            </Typography>
            <Popover
                id={id}
                open={open}
                anchorEl={toggleProfile}
                onClose={() => setToggleProfile(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                sx={popoverStyle}
            >
                <List>
                    <MenuItem
                        onClick={() => {
                            navigate('/user/me');
                            setToggleProfile(null);
                        }}
                    >
                        <ListItemIcon>
                            <PersonIcon />
                        </ListItemIcon>
                        <ListItemText>{t('users.myProfile')}</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            setToggleProfile(null);
                            guard(() => {
                                logoutUser();
                                navigate('/', { replace: true });
                            });
                        }}
                    >
                        <ListItemIcon>
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText>{t('common.logout')}</ListItemText>
                    </MenuItem>
                </List>
            </Popover>
        </>
    );
}

export default Profile;
